import React from "react";
import { loadMap } from "./utils/map";

import "./styles.css";


function themeToBasemap(theme) {
  return theme === "light" ? "gray" : "dark-gray";
}

class ArcGISEnviro extends React.Component {
  constructor(props) {
    super(props);
    this.mapDiv = React.createRef();
  }

  componentDidMount() {
    const { theme, onLoad } = this.props;
    // use the ref as a container
    const container = this.mapDiv.current;
    const basemap = themeToBasemap(theme);
    
    loadMap(container, basemap).then(view => {
      this._view = view; // hold on to the view for later
      onLoad && onLoad();
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.theme !== prevProps.theme) {
      if (this._view) {
        const basemap = themeToBasemap(this.props.theme);
        this._view.map.basemap = basemap;
      }
    }
  }
  componentWillUnmount() {
    if (this._view) {
      this._view.container = null;
      delete this._view;
    }
  }
  render() {
    return <div className="esri-map" ref={this.mapDiv} />;
  }
}

export default ArcGISEnviro;
